export const LS_PREFIX = 'channels.';

export const USER_STORAGE_KEY = `${LS_PREFIX}user`;

export const LAST_TAB_HEARTBEAT_KEY = `${LS_PREFIX}lastTabHeartbeat`;

export const TAB_SESSION_ACTIVE_KEY = `${LS_PREFIX}tabSessionActive`;

export const TAB_PING_STORAGE_KEY = 'tabPing';

export const TAB_PONG_STORAGE_KEY = 'tabPong';

export const TAB_LOGOUT_STORAGE_KEY = 'tabLogout';

export const HEARTBEAT_STALE_MS = 2000;

export function isPageReload(): boolean
{
  const entry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
  return entry?.type === 'reload';
}

export function hasTabSessionMarker(): boolean
{
  return sessionStorage.getItem(TAB_SESSION_ACTIVE_KEY) === '1';
}

export function markTabSessionActive(): void
{
  sessionStorage.setItem(TAB_SESSION_ACTIVE_KEY, '1');
}

export function isNewBrowserTabContext(): boolean
{
  return !isPageReload() && !hasTabSessionMarker();
}

export function hasStoredUser(): boolean
{
  const raw = localStorage.getItem(USER_STORAGE_KEY);
  return raw !== null && raw !== '' && raw !== 'null';
}

export function isSessionHeartbeatStale(now = Date.now()): boolean
{
  const raw = localStorage.getItem(LAST_TAB_HEARTBEAT_KEY);
  if (!raw)
  {
    return true;
  }

  const lastBeat = Number(raw);
  if (Number.isNaN(lastBeat))
  {
    return true;
  }

  return now - lastBeat > HEARTBEAT_STALE_MS;
}

export function updateHeartbeat(now = Date.now()): void
{
  localStorage.setItem(LAST_TAB_HEARTBEAT_KEY, now.toString());
}

export function clearTabSessionHeartbeat(): void
{
  localStorage.removeItem(LAST_TAB_HEARTBEAT_KEY);
}

export function clearUserStorage(): void
{
  localStorage.removeItem(USER_STORAGE_KEY);
  clearTabSessionHeartbeat();
}

/**
 * Runs synchronously from main.ts before Angular bootstraps.
 * Clears a stale localStorage login when this is a new tab and no tab was active recently.
 * Full session teardown (WebSocket, permissions, etc.) runs via AuthenticationService.reset()
 * during APP_INITIALIZER when the ping path detects no other tab is alive.
 */
export function clearPersistedLoginBeforeBootstrap(): void
{
  if (!hasStoredUser())
  {
    return;
  }

  if (!isNewBrowserTabContext())
  {
    return;
  }

  if (!isSessionHeartbeatStale())
  {
    return;
  }

  clearUserStorage();
}
